var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0236 1.66669C5.42122 1.66669 1.69026 5.39765 1.69026 10C1.68297 11.9243 2.34925 13.7905 3.57359 15.275L1.90693 16.9417C1.67047 17.1813 1.60143 17.5397 1.73193 17.85C1.87348 18.1567 2.18614 18.3476 2.52359 18.3334H10.0236C14.626 18.3334 18.3569 14.6024 18.3569 10C18.3569 5.39765 14.626 1.66669 10.0236 1.66669ZM6.69026 9.16669C6.23002 9.16669 5.85693 9.53978 5.85693 10C5.85693 10.4603 6.23002 10.8334 6.69026 10.8334C7.1505 10.8334 7.52359 10.4603 7.52359 10C7.52359 9.53978 7.1505 9.16669 6.69026 9.16669ZM10.0236 9.16669C9.56335 9.16669 9.19026 9.53978 9.19026 10C9.19026 10.4603 9.56335 10.8334 10.0236 10.8334C10.4838 10.8334 10.8569 10.4603 10.8569 10C10.8569 9.53978 10.4838 9.16669 10.0236 9.16669ZM12.5236 10C12.5236 9.53978 12.8967 9.16669 13.3569 9.16669C13.8172 9.16669 14.1903 9.53978 14.1903 10C14.1903 10.4603 13.8172 10.8334 13.3569 10.8334C12.8967 10.8334 12.5236 10.4603 12.5236 10ZM4.53193 16.6667H10.0236C13.2039 16.6642 15.9397 14.4156 16.5579 11.2959C17.176 8.17617 15.5045 5.05421 12.5654 3.83911C9.62636 2.62402 6.23823 3.65417 4.47295 6.29962C2.70766 8.94507 3.05683 12.4691 5.30693 14.7167C5.46394 14.8705 5.5538 15.0802 5.55693 15.3C5.556 15.5227 5.46597 15.7358 5.30693 15.8917L4.53193 16.6667Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.cca70665f155951f5cd87b55a5bfb961.svg";
export { ForwardRef as ReactComponent };